export const PAGE_NOT_FOUND = {
  primaryTitle: '404',
  secondaryTitle: 'Page not found',
  message: "Sorry, we couldn't find the page you're looking for.",
};

export const CONFIGURATION_ISSUE = {
  primaryTitle: 'Oh no!',
  secondaryTitle:
    "We're experiencing an issue that's preventing us from completing your booking online.",
};
